import { Tooltip } from '~/components';
import { truncateStyles } from '~/pages/StoragePage/components/styles';

const TruncatedCell = ({ value }: { value: string }) => {
  return (
    <Tooltip title={value}>
      <div style={truncateStyles}>{value}</div>
    </Tooltip>
  );
};

export default TruncatedCell;
